var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronTop = function SvgChevronTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m10 5.722 6.32 7.222H3.68zM10 8l-3.014 3.444h6.028z",
    clipRule: "evenodd"
  })));
};
export { SvgChevronTop as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDIwIDIwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEwIDUuNzIyMTdMMTYuMzE5NSAxMi45NDQ0TDMuNjgwNTEgMTIuOTQ0NEwxMCA1LjcyMjE3Wk0xMCA4LjAwMDA2TDYuOTg2MTYgMTEuNDQ0NEwxMy4wMTM4IDExLjQ0NDRMMTAgOC4wMDAwNloiIC8+Cjwvc3ZnPgo=";